<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>海外事务管理</el-breadcrumb-item>
      <el-breadcrumb-item>全球赛报名管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack" style="margin-top: 10px"></el-page-header>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form :model="queryForm" class="filter_Form" label-width="100px" ref="queryFormRef">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="国家" prop="nationality">
              <el-select v-model="queryForm.nationality" placeholder="请选择国家" clearable filterable style="width: 100%">
                <el-option v-for="item in countryList" :key="item.id" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button type="primary" style="width: 100%" @click="getDataList('search')">查询</el-button>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset">重置</el-button>
        </el-col>
        <!-- <el-col :span="2">
          <el-button type="success" style="width: 100%" @click="handleAdd">新增</el-button>
        </el-col> -->
      </el-row>
    </el-card>
    <!-- 列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col :span="12">
          <span class="title_class">全球赛报名列表</span>
        </el-col>
        <el-col :span="12" align="right">
          <el-button type="primary" plain @click="exportFn">导出列表</el-button>
        </el-col>
      </el-row>
      <el-table header-cell-class-name="tableHeaderStyle" :data="dataList" border stripe>
        <el-table-column label="序号" type="index" width="60px"></el-table-column>
        <el-table-column label="联系邮箱" prop="contactEmail" min-width="180"></el-table-column>
        <el-table-column label="国家" prop="countryName" min-width="120"></el-table-column>
        <el-table-column label="名" prop="firstName" min-width="100"></el-table-column>
        <el-table-column label="姓" prop="lastName" min-width="100"></el-table-column>
        <el-table-column label="城市" prop="city" min-width="120"></el-table-column>
        <el-table-column label="出生日期" prop="birthDate" min-width="120"></el-table-column>
        <el-table-column label="T恤尺码" prop="tshirtSize" width="100"></el-table-column>
        <el-table-column label="随行家长数量" prop="parentsNumber" width="120"></el-table-column>
        <el-table-column label="操作" width="150px" fixed="right">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button> -->
            <el-button type="text" size="small" style="color: #f56c6c" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px"
      >
      </el-pagination>
    </el-card>
    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="editDialogVisible" width="50%" @close="editDialogClose">
      <el-form :model="editForm" label-width="130px" ref="editFormRef" :rules="editRules" style="width: 100%">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名" prop="firstName">
              <el-input v-model="editForm.firstName" placeholder="请输入名" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓" prop="lastName">
              <el-input v-model="editForm.lastName" placeholder="请输入姓" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系邮箱" prop="contactEmail">
              <el-input v-model="editForm.contactEmail" placeholder="请输入联系邮箱" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="国家" prop="nationality">
              <el-input v-model="editForm.nationality" placeholder="请输入国家" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="城市" prop="city">
              <el-input v-model="editForm.city" placeholder="请输入城市" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出生日期" prop="birthDate">
              <el-date-picker
                v-model="editForm.birthDate"
                type="date"
                placeholder="请选择日期"
                style="width: 100%"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="T恤尺码" prop="tshirtSize">
              <el-select v-model="editForm.tshirtSize" placeholder="请选择" style="width: 100%">
                <el-option label="S" value="S"></el-option>
                <el-option label="M" value="M"></el-option>
                <el-option label="L" value="L"></el-option>
                <el-option label="XL" value="XL"></el-option>
                <el-option label="XXL" value="XXL"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="随行家长数量" prop="parentsNumber">
              <el-input-number
                v-model="editForm.parentsNumber"
                :min="0"
                :max="20"
                placeholder="请输入"
                style="width: 100%"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import env from '@/http/env'
import {
  getNationalOverseasRegistPage,
  addNationalOverseasRegist,
  updateNationalOverseasRegist,
  deleteNationalOverseasRegist,
  getCountryList
} from '@/http/api'

export default {
  data () {
    return {
      queryForm: {
        nationality: '',
        pageNum: 1,
        pageSize: 10
      },
      dataList: [],
      countryList: [],
      total: 0,
      editDialogVisible: false,
      dialogTitle: '新增',
      editForm: {
        id: null,
        contactEmail: '',
        nationality: '',
        firstName: '',
        lastName: '',
        city: '',
        birthDate: '',
        tshirtSize: '',
        parentsNumber: 0
      },
      editRules: {
        contactEmail: [
          { required: true, message: '请输入联系邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        nationality: [{ required: true, message: '请输入国家', trigger: 'blur' }],
        firstName: [{ required: true, message: '请输入名', trigger: 'blur' }],
        lastName: [{ required: true, message: '请输入姓', trigger: 'blur' }],
        city: [{ required: true, message: '请输入城市', trigger: 'blur' }],
        tshirtSize: [{ required: true, message: '请选择T恤尺码', trigger: 'change' }]
      }
    }
  },
  created () {
    if (this.$route.query.type === '2') {
      this.queryForm.loginType = 'noLogin'
    } else {
      this.queryForm.loginType = 'login'
    }
    this.getDataList()
    this.getCountryList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    // 获取列表
    getDataList (getType) {
      if (getType === 'search') {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = 10
      }
      getNationalOverseasRegistPage(this.queryForm).then((res) => {
        console.log('getNationalOverseasRegistPage', res)
        this.dataList = res.data.list || []
        this.total = res.data.total || 0
      }).catch((err) => {
        console.log('err', err)
        this.$message.error('获取列表失败')
      })
    },
    // 重置搜索条件
    reset () {
      this.$refs.queryFormRef.resetFields()
      this.getDataList()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    },
    // 新增
    handleAdd () {
      this.dialogTitle = '新增'
      this.editForm = {
        id: null,
        contactEmail: '',
        nationality: '',
        firstName: '',
        lastName: '',
        city: '',
        birthDate: '',
        tshirtSize: '',
        parentsNumber: 0
      }
      this.editDialogVisible = true
    },
    // 编辑
    handleEdit (row) {
      this.dialogTitle = '编辑'
      this.editForm = {
        id: row.id,
        contactEmail: row.contactEmail,
        nationality: row.nationality,
        firstName: row.firstName,
        lastName: row.lastName,
        city: row.city,
        birthDate: row.birthDate,
        tshirtSize: row.tshirtSize,
        parentsNumber: row.parentsNumber
      }
      this.editDialogVisible = true
    },
    // 提交新增/编辑
    submitEdit () {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return
        if (this.editForm.id) {
          updateNationalOverseasRegist(this.editForm).then((res) => {
            console.log('updateNationalOverseasRegist', res)
            this.$message.success('编辑成功')
            this.editDialogVisible = false
            this.getDataList()
          }).catch((err) => {
            console.log('编辑失败', err)
            this.$message.error('编辑失败')
          })
        } else {
          addNationalOverseasRegist(this.editForm).then((res) => {
            console.log('addNationalOverseasRegist', res)
            this.$message.success('新增成功')
            this.editDialogVisible = false
            this.getDataList()
          }).catch((err) => {
            console.log('新增失败', err)
            this.$message.error('新增失败')
          })
        }
      })
    },
    // 关闭对话框
    editDialogClose () {
      this.$refs.editFormRef.resetFields()
      this.editForm = {
        id: null,
        contactEmail: '',
        nationality: '',
        firstName: '',
        lastName: '',
        city: '',
        birthDate: '',
        tshirtSize: '',
        parentsNumber: 0
      }
    },
    // 删除
    handleDelete (row) {
      this.$confirm('确认删除该条记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = { id: row.id }
        deleteNationalOverseasRegist(params).then((res) => {
          console.log('deleteNationalOvoicesRegist', res)
          this.$message.success('删除成功')
          this.getDataList()
        }).catch((err) => {
          console.log('删除失败', err)
          this.$message.error('删除失败')
        })
      }).catch(() => {
        // 用户取消删除
      })
    },
    // 获取国家列表
    getCountryList () {
      getCountryList({}).then((res) => {
        if (res.code === 200) {
          this.countryList = res.data || []
        }
      }).catch((err) => {
        console.log('getCountryList err', err)
      })
    },
    exportFn () {
      const downLoadUrl = `${env.baseIP}nationalOverseas/regist/export`
      // this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl)
      this.$downLoadFile.downLoadFileWithUrlNew(this, downLoadUrl, this.queryForm)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
